import { render, staticRenderFns } from "./test_history.vue?vue&type=template&id=3de79612&scoped=true&"
import script from "./test_history.vue?vue&type=script&lang=js&"
export * from "./test_history.vue?vue&type=script&lang=js&"
import style0 from "./test_history.vue?vue&type=style&index=0&id=3de79612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de79612",
  null
  
)

export default component.exports